import EnterpriseFeatures from './EnterpriseFeatures';

export default {
  EnterpriseFeatures,
};
